import { Pipe, PipeTransform } from '@angular/core';
import { AlignmentType } from '@shared/enums/AlignmentType';

@Pipe({ name: 'alignmentFlex'})
export class AlignmentFlexTypePipe implements PipeTransform {

  public transform(type: AlignmentType): string {
    let alignment = 'd-flex ';
    switch (type) {
      case AlignmentType.Left:
        alignment += 'justify-content-start align-items-start';
        break;
      case AlignmentType.Center:
        alignment += 'justify-content-center align-items-center';
        break;
      case AlignmentType.Right:
        alignment += 'justify-content-end align-items-end';
        break;
    }
    return alignment;
  }
}
